"use strict";

angular.module("customer")
.controller("SectionShoppingCart", function(
    $rootScope, $scope, $state, $resource, $timeout, $http, $q, $cookies, $filter, gettextCatalog, FlashBag,
    ModalService, common, appConfig,
    CartItemService, StocksService, CartVendorService, FormError, Language, PreferredService, RetailerUserInfoService,
    UserService, PreviousStateService, PatternService, CustomerOrderService, PunchOutService, ReadOnlyPermissionService,
    VendorInventoryExternalSyncService, OrderTemplateService,
    PRODUCT_ACQUISITION_METHOD
) {
    var _this = this;
    var promises = [];
    $scope.PO_NUMBER_MAX_LENGTH = 22;
    $scope.NOTE_MAX_LENGTH = 200;
    $scope.pattern = PatternService;
    $scope.ShoppingCart = null;
    $scope.isOrderBeingModified = null;
    $scope.showInventory = false;
    $scope.showPaymentButton = false;
    $scope.submitOrderButtonDisabled = false;
    $scope.isOrderTemplateWeekdaysValid = true;
    $scope.PRODUCT_ACQUISITION_METHOD = PRODUCT_ACQUISITION_METHOD;

    $scope.SUBMIT_BUTTON_TYPE = {
        TRANSMIT: "transmit",
        TRANSMIT_AND_INVOICE: "transmit-and-invoice",
        TRANSMIT_INVOICE_AND_PRINT: "transmit-invoice-and-print"
    }
    $scope.defaultSubmitButton = $cookies.get('default-submit-button');
    if (!$scope.defaultSubmitButton) {
        $scope.defaultSubmitButton = $scope.SUBMIT_BUTTON_TYPE.TRANSMIT;
    }

    Language.initializeScope($scope, "language", "locale");

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user) {
            $scope.dedicatedVendorId = user.dedicated_vendor_id;
            $scope.canInvoice = !!user.info && user.info.can_invoice && !!$scope.dedicatedVendorId;

            if (user.customer) {
                $scope.RetailerInfo = user.customer;
            }
        }
    });

    this.back = function() {
        var previousState = PreviousStateService.getPreviousState();
        if (this.isPreviousStateIsStock()) {
            $state.go(previousState.name, previousState.params);
        }
        else {
            $state.go("home");
        }
    };

    this.isPreviousStateIsStock = function() {
        var previousState = PreviousStateService.getPreviousState();
        return previousState.name === "stocks";
    };

    this.validate = function() {
        $scope.submitShoppingCart = true;
        FormError.focus("FormShoppingCart");
    };

    this.saveCartVendorAndRefreshCart = function(vendor) {
        if (!vendor.standing_order_id) {
            saveCartVendorAndRefreshCart(vendor);
        }
        else if (vendor.standing_order_id && vendor.delivery_date !== vendor.initial_delivery_date) {
            // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
            ModalService.showModal({
                templateUrl: require("core/confirmation/confirmation.modal.html"),
                controller: "Confirmation",
                controllerAs: "ConfirmationCtrl",
                inputs: {
                    $attrs: {
                        title: gettextCatalog.getString("Cancel standing order"),
                        message: gettextCatalog.getString("If you change the delivery date, this standing order will be cancelled."),
                        confirmTextButton: gettextCatalog.getString("Confirm")
                    }
                }
            }).then(function onSuccess(modal) {
                modal.element.modal({
                    backdrop: "static",
                    keyboard: false
                });
                modal.close.then(function(confirm) {
                    vendor.cancelStandingOrder = false;
                    if (confirm) {
                        vendor.cancelStandingOrder = true;
                        saveCartVendorAndRefreshCart(vendor);
                    }
                    else {
                        vendor.delivery_date = vendor.initial_delivery_date;
                    }
                });
            });
        }
    };

    function saveCartVendorAndRefreshCart(vendor) {
        _this.saveCartVendor(vendor);
        $q.all(promises).then(function() {
            StocksService.updateDeliveryData(vendor);
            fetchCart();
        });
        FlashBag.clearAll();
    }

    this.onNoteClick = function(vendor) {
        if (!vendor.note || !vendor.noteExpanded) {
            vendor.noteExpanded = !vendor.noteExpanded;
        }
    };

    this.cancelOrderModification = function(orderId) {
        CustomerOrderService.cancelOrderModification(orderId);
    };

    this.cancelOrderTemplateModification = function(cartVendorId, orderTemplateId) {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Cancel template modification"),
                    message: gettextCatalog.getString("Do you really want to cancel the modification of this template?"),
                    confirmTextButton: gettextCatalog.getString("Confirm")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.close.then(function(confirm) {
                if (!confirm) {
                    return;
                }
                CartVendorService.deleteCartVendor(cartVendorId).then(function onSuccess() {
                    $rootScope.UpdateCartItemsNumber();
                    if (orderTemplateId) {
                        $state.go('orderTemplateDetails', {id: orderTemplateId});
                    }
                    else {
                        $state.go('orderTemplateList');
                    }
                });
            });
        });
    };

    this.saveOrderTemplate = function(cartVendorId, orderTemplateData) {
        $scope.submitShoppingCart = true;
        if (!$scope.FormShoppingCart.$valid) {
            FormError.focus("FormShoppingCart");
            return;
        }

        var data = angular.extend(orderTemplateData, {cart_vendor_id: cartVendorId});
        var method = OrderTemplateService.create;
        var message = gettextCatalog.getString("The template was created successfully.");
        if (orderTemplateData.id) {
            method = OrderTemplateService.update;
            message = gettextCatalog.getString("The template was updated successfully.");
        }
        method(data).$promise.then(function onSuccess(data) {
            OrderTemplateService.orderTemplateName = "";
            $rootScope.UpdateCartItemsNumber();

            if (data.has_standing_order_deadline_today) {
                FlashBag.clearAll();
                openTodayStandingOrderConfirmationModal(data.id);
            }
            else {
                FlashBag.success(message, true);
                $state.go('orderTemplateDetails', {id: data.id});
            }
        });
    };

    this.validateOrderTemplateWeekdays = function(vendor) {
        if (
            !vendor.is_order_template
            || !vendor.order_template
            || !vendor.order_template.standing_order_enabled
            || (vendor.enabled_delivery_weekdays && vendor.enabled_delivery_weekdays.length <= 1)
            || (
                vendor.order_template.standing_order_delivery_weekdays
                && vendor.order_template.standing_order_delivery_weekdays.length === 0
            )
        ) {
            $scope.isOrderTemplateWeekdaysValid = true;
            return;
        }

        $timeout(function() {
            var vendorDuplicatedWeekdays = {};
            angular.forEach(vendor.delivery_rules, function(deliveryRule) {
                angular.forEach(vendor.delivery_rules, function(deliveryRule_) {
                    if (
                        deliveryRule.id !== deliveryRule_.id && deliveryRule.enabled && deliveryRule_.enabled
                        && deliveryRule.threshold_local_weekday === deliveryRule_.threshold_local_weekday
                        && deliveryRule.weekday !== deliveryRule_.weekday
                    ) {
                        if (!vendorDuplicatedWeekdays.hasOwnProperty(deliveryRule.weekday)) {
                            vendorDuplicatedWeekdays[deliveryRule.weekday] = [deliveryRule_.weekday];
                        }
                        else {
                            vendorDuplicatedWeekdays[deliveryRule.weekday].push(deliveryRule_.weekday);
                        }
                    }
                });
            });

            vendor.invalidWeekdays = [];
            angular.forEach(vendor.order_template.standing_order_delivery_weekdays, function(weekday) {
                angular.forEach(vendor.order_template.standing_order_delivery_weekdays, function(weekday_) {
                    if (
                        vendorDuplicatedWeekdays.hasOwnProperty(weekday)
                        && vendorDuplicatedWeekdays[weekday].includes(weekday_)
                        && !vendor.invalidWeekdays.includes(weekday)
                    ) {
                        vendor.invalidWeekdays.push(weekday);
                    }
                });
            });

            $scope.isOrderTemplateWeekdaysValid = !(vendor.invalidWeekdays.length);
        });
    };

    function openTodayStandingOrderConfirmationModal(orderTemplateId) {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Today standing order available"),
                    message: gettextCatalog.getString("The template was saved successfully and a standing order is available today and could automatically be sent at the deadline, do you want to generate the cart?"),
                    confirmTextButton: gettextCatalog.getString("Confirm")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.close.then(function(confirm) {
                if (!confirm) {
                    $state.go('orderTemplateDetails', {id: orderTemplateId});
                    return;
                }
                OrderTemplateService.generateCartStandingOrderFromOrderTemplateFromOrder(orderTemplateId)
                .then(function onSuccess() {
                    FlashBag.success(gettextCatalog.getString("The cart was generated successfully. The standing order should be sent at the deadline."), true);
                    $rootScope.UpdateCartItemsNumber();
                    fetchCart();
                }, function onError() {
                    FlashBag.error(gettextCatalog.getString("An error occurs during the generation of the cart. See the template's logs for more details."), true);
                    $state.go('orderTemplateDetails', {id: orderTemplateId});
                });
            });
        });
    }

    this.saveCartVendor = function(vendor) {
        // Call a blur event on the dropdown element to showing up the footer on mobile
        var selectElement = document.getElementById("select-delivery-date-" + vendor.id);
        if (selectElement) {
            selectElement.blur();
        }

        updateCartVendor(vendor);
    };

    this.emptyCart = function(vendor) {
        var message = gettextCatalog.getString("Do you really want to empty the vendor's cart?");
        if (vendor.standing_order) {
            message = gettextCatalog.getString("This action will cancel your standing order. Do you really want to empty the vendor's cart?");
        }
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Empty cart"),
                    message: message,
                    confirmTextButton: gettextCatalog.getString("Confirm")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.close.then(function(confirm) {
                if (!confirm) {
                    return;
                }
                CartVendorService.deleteCartVendor(vendor.cart_vendor_id).then(function onSuccess() {
                    $rootScope.UpdateCartItemsNumber();
                    fetchCart();
                });
            });
        });
    };

    this.setDefaultSubmitButton = function(value) {
        $scope.defaultSubmitButton = value;
        $cookies.put('default-submit-button', value);
    }

    this.submitOrder = function(submitButtonType) {
        if ($scope.submitOrderButtonDisabled) {
            return;
        }

        $scope.submitOrderButtonDisabled = true;

        if (!submitButtonType) {
            submitButtonType = $scope.defaultSubmitButton;
        }
        this.setDefaultSubmitButton(submitButtonType);

        var url = appConfig.API_SERVER + "/catalog/customer/orders/submit/";
        if (
            $scope.defaultSubmitButton === $scope.SUBMIT_BUTTON_TYPE.TRANSMIT_AND_INVOICE
            || $scope.defaultSubmitButton === $scope.SUBMIT_BUTTON_TYPE.TRANSMIT_INVOICE_AND_PRINT
        ) {
            url = appConfig.API_SERVER + "/catalog/customer/orders/submit-order-and-invoice/";
        }

        this.submit(url);
    }

    this.submit = function(url, data) {
        $scope.showPaymentButton = false;
        angular.forEach($scope.ShoppingCart, function(vendor, key) {
            if (!vendor.standing_order_id) {
                updateCartVendor(vendor);
            }
        });

        $q.all(promises).then(function() {
            return syncVendorExternalInventory();
        }).then(function() {
            $http({
                method: "POST",
                url: url,
                data: data
            }).then(function onSuccess(response) {
                var data = response.data;
                var showInvoicePrintButtons = $scope.defaultSubmitButton === $scope.SUBMIT_BUTTON_TYPE.TRANSMIT_INVOICE_AND_PRINT;
                var showViewInvoicesButton = $scope.defaultSubmitButton === $scope.SUBMIT_BUTTON_TYPE.TRANSMIT_AND_INVOICE || showInvoicePrintButtons;
                showViewInvoicesButton = showViewInvoicesButton || data.invoices_submitted;
                var displayErrorMessage = data.orders_sent !== data.orders_submitted || data.warnings_detail.length;

                if (data.extra.punch_out) {
                    PunchOutService.orderSubmitted(data.extra.punch_out);
                }
                else {
                    $rootScope.UpdateCurrentNumbers();
                    if (data.orders_sent) {
                        $state.go("orderConfirmation", {
                            order: data,
                            show_view_invoices_button: showViewInvoicesButton,
                            show_invoice_print_buttons: showInvoicePrintButtons,
                            display_error_message: displayErrorMessage
                        });
                    }

                    if (displayErrorMessage) {
                        if (data.errors_detail.length) {
                            CartVendorService.showWarningMessages(data.errors_detail);
                        }
                        if (data.warnings_detail.length) {
                            CartVendorService.showWarningMessages(data.warnings_detail);
                        }
                        refreshCart();
                    }
                }
            }, function onError(response) {
                var showAPIErrors = true;
                ReadOnlyPermissionService.handleResponseError(response);

                $scope.showPaymentButton = CartVendorService.isPaymentTermsError(response.data);
                if (CartVendorService.isPreAuthorizedPaymentAgreementError(response.data)) {
                    showAPIErrors = false;
                    $scope.showPreAuthorizedPaymentAgreementAlert = true;
                    $scope.preAuthorizedError = CartVendorService.getFirstPreAuthorizedPaymentAgreementError(response.data);
                }
                if (CartVendorService.isInventoryQuantityWarningError(response.data)) {
                    CartVendorService.openInventoryWarningModal(response.data.warnings_detail)
                    .then(function onSuccess() {
                        _this.submit(url, {user_ignore_inventory_validation: true});
                    });
                }

                if (showAPIErrors) {
                    FlashBag.apiError(response);
                }
                refreshCart();
            });
        });
    };

    this.ignoreInvalidDeliveryWarning = function(vendor) {
        vendor.is_delivery_date_updated = false;
        vendor.has_valid_rule = true;
    };

    this.isOrderAmountValid = function(order) {
        return CartItemService.isOrderAmountValid(order);
    };

    this.isOrderQuantityValid = function(order) {
        return CartItemService.isOrderQuantityValid(order);
    };

    // order error messages
    this.getOrderAmountError = function(order) {
        return CartItemService.getOrderAmountError(order);
    };

    this.getOrderQuantityError = function(order) {
        return CartItemService.getOrderQuantityError(order);
    };

    this.isOrderExistsWithCurrentDeliveryDate = function(vendor) {
        return vendor.list_of_delivery_dates_with_existing_order.indexOf(vendor.delivery_date) !== -1;
    };

    this.getStandingOrderAvailableDeliveryWeekdays = function(selectedWeekdays, availableWeekdays) {
        return OrderTemplateService.getStandingOrderAvailableDeliveryWeekdays($scope.weekdays, selectedWeekdays, availableWeekdays);
    };

    this.getStandingOrderUnavailableDeliveryWeekdays = function(selectedWeekdays, availableWeekdays) {
        return OrderTemplateService.getStandingOrderUnavailableDeliveryWeekdays($scope.weekdays, selectedWeekdays, availableWeekdays);
    };

    this.keepOrderTemplateNameInMemory = function(vendor) {
        OrderTemplateService.orderTemplateName = vendor.order_template.name;
    };

    function updateCartVendor(vendor) {
        var promise = CartVendorService.updateCartVendor(vendor);
        promises.push(promise);
    }

    function fetchCart() {
        var deferred = $q.defer();
        CartItemService.fetchCart().then(function(data) {
            $scope.ShoppingCart = data;
            if ($scope.ShoppingCart.length) {
                $scope.isOrderBeingModified = $scope.ShoppingCart[0].is_order_being_modified;
                $scope.isOrderTemplate = _.find($scope.ShoppingCart, function(vendor) {
                    return vendor.is_order_template === true;
                });
                $scope.ShoppingCart.some(function(vendor) {
                    if (vendor.allow_customer_to_add_order_notes || vendor.note) {
                        vendor.noteExpanded = true;
                    }
                    if (vendor.is_order_template) {
                        _this.validateOrderTemplateWeekdays(vendor);
                        if (OrderTemplateService.orderTemplateName) {
                            if (!vendor.order_template) {
                                vendor.order_template = {};
                            }
                            vendor.order_template.name = OrderTemplateService.orderTemplateName;
                        }
                    }
                });
            }
            $scope.isShoppingCartLoaded = true;
            UserService.isUserFetched().then(function onSuccess(user) {
                $scope.showInventory = !!(user && user.info && user.info.customer_catalog_view_selected === "inventory");
                if (user && user.dedicated_vendor_id) {
                    CartVendorService.updateDeliveryDateList($scope.ShoppingCart);
                }
                deferred.resolve(true);
            });
        }, function onError() {
            $scope.ShoppingCart = [];
            $scope.isShoppingCartLoaded = false;
            deferred.resolve(true);
        });
        return deferred.promise;
    }

    function syncVendorExternalInventory() {
        var inventorySyncPromises = [];
        var deferred = $q.defer();
        if ($scope.ShoppingCart) {
            $scope.ShoppingCart.some(function(vendor) {
                if (vendor.has_external_sync_config) {
                    var productIds = [];
                    vendor.orders.some(function(order) {
                        order.cart_items.some(function(cart_item) {
                            if (!cart_item.is_return) {
                                productIds.push(cart_item.catalog_entry.product.id);
                            }
                        });
                    });
                    if (!productIds) {
                        return;
                    }
                    var promise = VendorInventoryExternalSyncService.syncProductInventory(vendor.id, productIds);
                    inventorySyncPromises.push(promise);
                }
            });
        }
        $q.all(inventorySyncPromises).finally(function() {
            deferred.resolve(true);
        });
        return deferred.promise;
    }

    function refreshCart() {
        fetchCart().then(function onSuccess() {
            $scope.submitOrderButtonDisabled = false;
        });
    }

    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(event, newLocale) {
        setWeekdays(newLocale);
    });

    $scope.$on("$destroy", function() {
        unregisterLanguageChanged();
    });

    function setWeekdays(locale) {
        $scope.weekdays = common.getISOWeekdays(locale);
    }

    setWeekdays($scope.locale);

    fetchCart();

    $scope.$on("updateCart", function() {
        CartItemService.updateCart($scope.ShoppingCart);
    });

    $scope.$on("fetchCart", function() {
        fetchCart();
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/cart/shopping-cart.controller.js
// module id = 940
// module chunks = 0